export const PARTNER_TYPES = [
  "Shipowner / ship manager",
  "Shipyard",
  "Robotics company",
  "Marine equipment manufacturer",
  "Sensors & control systems",
  "Autonomy company",
  "University / research institution",
  "Infrastructure & ports",
  "Other",
];

export const FOCUS_AREAS = [
  "Navigation & autonomy",
  "Sensing & perception",
  "Robotics & maintenance",
  "Machinery & power",
  "Cargo handling",
  "Communications & shore operations",
  "Vessel design & construction",
  "Fleet operations & pilots",
];

export const PARTNER_GROUPS = [
  { k: "Shipowners & managers", v: "Operational insight, trial vessels and the routes where autonomy pays first." },
  { k: "Shipyards", v: "Building and converting ships designed to run with no one aboard." },
  { k: "Robotics companies", v: "Robots that can work aboard a ship at sea." },
  { k: "Marine equipment makers", v: "Machinery that machines can monitor, run and service." },
  { k: "Sensors & control systems", v: "Perception, telemetry and control that hold up at sea." },
  { k: "Autonomy companies", v: "Navigation, collision avoidance and decision-making." },
  { k: "Universities & research", v: "Marine autonomy, robotics and reliable AI." },
  { k: "Ports & terminals", v: "Trial calls and operational insight. Our ships adapt to your port, not the other way round." },
];

export const PARTNER_STEPS = [
  { k: "01", t: "Tell us what you've built", v: "A short note on your technology and the problem it solves." },
  { k: "02", t: "We map it to the ship", v: "Where it fits, what it replaces and what it needs." },
  { k: "03", t: "Integrate and demonstrate", v: "Pilots and joint demonstrations, clearly credited." },
];
